module.exports = __webpack_public_path__ + "static/images/biditem8_0579a1fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tab/content/biditem8.png
// module id = 247
// module chunks = 1